import type { AuthenticationState, User } from '@/types';
import { X4bUserRoleEnum } from '@/constants/roles';
import { produce } from 'immer';

const initialState = {
	isHydrated: false,
	accessToken: null,
	user: {
		email: '',
		firstName: '',
		lastName: '',
		roleId: undefined,
	},
};

export const createAuthenticationStore = (
	set: (
		state:
			| Partial<AuthenticationState>
			| ((state: AuthenticationState) => Partial<AuthenticationState>),
	) => void,
	get: () => AuthenticationState,
) => ({
	...initialState,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	setAccessToken: (accessToken: string) =>
		set(
			produce((state: AuthenticationState) => {
				state.accessToken = accessToken;
			}),
		),
	removeAccessToken: () =>
		set(
			produce((state: AuthenticationState) => {
				state.accessToken = initialState.accessToken;
			}),
		),
	setUser: (user: User) =>
		set(
			produce((state: AuthenticationState) => {
				state.user = user;
			}),
		),
	hasRoles: (roles: X4bUserRoleEnum[]): boolean => {
		const state = get();
		const userRoleId = state.user.roleId ? parseInt(state.user.roleId) : 0;
		return roles.includes(userRoleId as X4bUserRoleEnum);
	},
});
